import type { UserProfile1 } from '../types';

/**
 * Gets all maps that a user has access to from their user profile.
 * This includes both maps they own and maps shared with them.
 *
 * @param userProfile - The user profile to get accessible maps for.
 * @returns An array of accessible maps with their uuid and title.
 */
export function getAccessibleMaps(userProfile: UserProfile1) {
  if (!userProfile) return [];

  const myMaps = userProfile.myMilestoneMaps || [];
  const sharedMaps = userProfile.sharedMilestoneMaps || [];

  // Use Map to deduplicate by uuid and only keep uuid and title
  return Array.from(
    new Map(
      [...myMaps, ...sharedMaps].map((map) => [map.uuid, { uuid: map.uuid, title: map.title }]),
    ).values(),
  );
}
